import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=3f37c825&scoped=true"
import script from "./Booking.vue?vue&type=script&lang=js"
export * from "./Booking.vue?vue&type=script&lang=js"
import style0 from "./Booking.vue?vue&type=style&index=0&id=3f37c825&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f37c825",
  null
  
)

export default component.exports